module.exports = __webpack_public_path__ + "img/9791189946166.e93f204e.jpg";